import styled from 'styled-components';
import { colors, fontFamilySize, px } from '../../../../../../../contrib/ui';

export const PlayerMetaDataSectionStyled = styled.div`
  width: 100%;
  .formcontrol-container {
    width: 100%;
    legend {
      ${fontFamilySize('Medium', 14)};
      color: ${colors.grey9b};
      height: ${px(25)};

      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      p {
        margin: 0;
        padding: 0;
        height: 100%;
        margin-top: ${px(3)};
        line-height: 2;
        margin-right: ${px(5)};
      }
    }

    .radiogroup-container {
      .index-type-container {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-evenly;

        .input-form-control,
        span.disabled-index {
          width: ${px(75)};
        }

        .input-form-control {
          .material-input.override {
            margin-top: 0;
          }
        }

        .spacer {
          flex-grow: 1;
        }

        .spacer2 {
          min-width: ${px(48)};
          width: ${px(48)};
        }

        span.disabled-index {
          text-align: center;
          ${fontFamilySize('Bold', 16)};
        }
      }
    }
  }
`;
